import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { BuyersResponse } from '../../dto/buyers-dto';
import { BuyersRequest } from '../../dto/buyers-dto';

/** Path version for `POST /api/{version}/lead`. v2 is the existing submit path. */
export type LeadApiVersion = 'v2' | 'v3';

type FetchBuyersOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
  apiVersion?: LeadApiVersion;
};

export function fetchBuyers(
  baseUrl: string,
  payload: BuyersRequest,
  options?: FetchBuyersOptions,
): Promise<IHttpResponse<BuyersResponse>> {
  const {
    httpCall = fetchBasedCall,
    headers,
    apiVersion = 'v2',
    ...restOptions
  } = options ?? {};

  const request: IHttpRequest<BuyersRequest> = {
    url: `${baseUrl}/api/${apiVersion}/lead`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: BuyersRequest,
      response: BuyersResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
